import React, { useCallback, useEffect, useState } from "react";
import { styled } from "@mui/system";
import { CardTile, useCommonLoader } from "carynhealth-component-library";
import {
  getProductTiles,
  encryptMemberId,
  getUserEmail,
  getRxSimpleShareData,
} from "./handlers";
import { useNavigate } from "react-router-dom";
import { Modal, IconButton, useTheme, useMediaQuery } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { isTablet, isMobile } from "react-device-detect";
import { getPlainIData } from "../../RightTopMemberTabs/handler";
import { getLocalStorage } from "carynhealth-component-library/dist/cjs/helpers/storage";
import config from "../../../config/constants/config";
import { StorageHelpers } from "carynhealth-component-library";
import routePaths from "../../../config/constants/routePaths";

const isNetwell = config.APP_NAME === config.BRAND_NETWELL;
const isCuramlife = config.APP_NAME === config.BRAND_CURAMLIFE;
const routes = routePaths[config.APP_NAME as keyof typeof routePaths];

const ProductTilesStyleWrapper = styled("div")(({ theme }) => {
  return {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    img: {
      width: isNetwell ? "auto !important" : "4vw !important",
      height: "4vw !important",
    },
    ".label-wrapper": {
      background: "red",
      fontWeight: 400,
    },
    ".cursor-hand-hover:hover .label-warapper span": {
      color: "#fff",
    },
    [theme.breakpoints.down(768)]: {
      ".cardTitle": {
        letterSpacing: ".9px !important",
      },
    },
  };
});

const Div = styled("div")(({ theme }) => {
  return {
    position: "absolute",
    top: "50%",
    left: "40%",
    transform: "translate(-50%, -50%)",
    width: 400,
    border: "none",
  };
});

const ModalID = styled(Modal)(({ theme }) => {
  return {
    display: "flex",
  };
});
const Iframe = styled("iframe")(({ theme }) => {
  return {
    width: process.env.REACT_APP_WIDTH,
    height: process.env.REACT_APP_HEIGHT,
    border: "none",
    margin: "auto",
  };
});
const Div1 = styled("div")(({ theme }) => {
  return {
    display: "flex",
    justifyContent: "flex-end",
    background: "#f1f1f1",
    borderTopLeftRadius: "5px",
    borderTopRightRadius: "5px",
    width: process.env.REACT_APP_WIDTH,
  };
});

const ProductTiles = () => {
  const navigate = useNavigate();
  const [loading, setLoadings] = useState(false);
  const { setLoading, unSetLoading } = useCommonLoader();
  const [modalIdUrl, setModalIdUrl] = useState("");
  const theme = useTheme();
  const showText = useMediaQuery(theme.breakpoints.down("md"));
  const [data, setData] = useState<any>({
    tiles: [],
    errorMessage: "",
  });
  const planId: any = getLocalStorage("planId");
  const fetchTilesData = async () => {
    if (loading) return false;
    try {
      const data = await getProductTiles();
      let sortedArr = data;
      const planID: any = getLocalStorage("planId");
      if (getPlainIData(planID) && !isNetwell) {
        sortedArr.tiles[0].list[1].label = "Advanced Health Tools";
      }
      setData(sortedArr);

      setLoadings(false);
    } catch (error: any) {
      setData({ tiles: [], ...(error || {}) });
      setLoadings(false);
    }
  };

  const clickHandler = useCallback((event: any, data: any) => {
    const lang = getLocalStorage("Language");
    if (data.href)
      if (lang === "es") {
        switch (data.title.props.text.toLocaleLowerCase()) {
          case "faqs":
            return window.open(routes.spanishFaq);
          default:
            return;
        }
      }else 
    return window.open(data.href);
    data?.to && navigate(data.to);
    setLoading();
    switch (data.text) {
      case "Membership Card":
        showIDCard();
        break;
      case "Health Tools":
        showHealthToolCard();
        break;
      case "Advanced Health Tools":
        showHealthToolCard();
        break;
      case "CuramLife IDCard":
        showCuramLifeCard();
        break;
      default:
    }
  }, []);

  const showIDCard = async () => {
    if (isMobile === true || isTablet === true) navigate("/MembershipCard");
    else {
      let token = localStorage.getItem("bearerToken");
      var response = await encryptMemberId(null);
      setModalIdUrl(
        process.env.REACT_APP_IDCARD_URL +
          `?query=${encodeURIComponent(response)}&token=${token}`
      );
    }
    unSetLoading();
  };
  const showCuramLifeCard = async () => {
    if (isMobile === true || isTablet === true) navigate("/MembershipCard");
    else {
      let token = localStorage.getItem("bearerToken");
      var response = await encryptMemberId(null);
      setModalIdUrl(
        process.env.REACT_APP_IDCARD_URL +
          `?query=${encodeURIComponent(response)}&token=${token}`
      );
    }
    unSetLoading();
  };
  const showHealthToolCard = async () => {
    if (isMobile === true || isTablet === true) navigate("/HealthToolCard");
    else {
      let token = localStorage.getItem("bearerToken");
      var response = await encryptMemberId(null);
      setModalIdUrl(
        process.env.REACT_APP_HEALTHTOOL_URL +
          `?query=${encodeURIComponent(response)}&token=${token}`
      );
    }
    unSetLoading();
  };

  async function setFlexBasis() {
    let isPlaid = await getPlainIData(planId);
    if (!isPlaid && !isNetwell && !showText) {
      const element: any = document.getElementById("product-tiles");
      if (element?.style) element.style.flexBasis = "60%";
    }
  }
  useEffect(() => {
    fetchTilesData();
    !isCuramlife && getRxSimpleShareData();
    getUserEmail();
    setFlexBasis();
  }, []);

  return (
    <>
      <ProductTilesStyleWrapper id="product-tiles">
        {data.tiles.map((tile: any) => (
          <CardTile key={tile.title} {...tile} onClick={clickHandler} />
        ))}
      </ProductTilesStyleWrapper>

      <ModalID open={modalIdUrl !== ""}>
        <Div>
          <Div1>
            <IconButton
              aria-label="close"
              onClick={() => setModalIdUrl("")}
              style={{
                color: "black",
                width: "30px",
                height: "30px",
              }}
            >
              <CloseIcon />
            </IconButton>
          </Div1>
          <Iframe src={modalIdUrl} />
        </Div>
      </ModalID>
    </>
  );
};

export default ProductTiles;
